import type { Milestone } from "../../types";

const nameLevels = (
  milestones: Milestone[] | undefined,
  levels: Record<string, string> | undefined,
) =>
  milestones?.map((milestone) => ({
    ...milestone,
    name: levels?.[atob(milestone.id)] ?? milestone.name,
  }));

export default nameLevels;
